import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';
import COLORS from '@ui-component-library/styles/colors';
import { INFO_TILE_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div`
    ${INFO_TILE_RESET}

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${SPACING.size16};
    border-radius: 8px;
    background-color: ${COLORS['white-50']};
    border: 1px solid ${COLORS['stone-100']};
    color: ${COLORS['charcoal-500']};
    gap: ${SPACING.size8};
    width: 100%;
  `,

  LeftContainer: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size16};
  `,

  Label: styled.p<{ $icon?: boolean }>`
    ${({ $icon }) => ($icon ? TYPOGRAPHY.labelMediumMedium : TYPOGRAPHY.overlineLargeRegular)}
    color: ${({ $icon }) => ($icon ? COLORS['charcoal-500'] : COLORS['pebble-500'])};
  `,

  RightContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  Value: styled.p`
    ${TYPOGRAPHY.bodySmallMedium}
  `
};
